module.exports = __webpack_public_path__ + "img/fanzhuan01.ca41006b.png";